import styled from 'styled-components';
import { spacings } from '../../../tokens/spacings';
import { theme } from '../../../tokens/theme';

export const NameFrame = styled.div`
  background-color: ${theme.light.ui.background.default};
  padding: ${spacings.LARGE} ${spacings.X_LARGE};
  margin: ${spacings.MEDIUM};
  width: fit-content;
  border: 1px solid ${theme.light.ui.background.medium};
  border-radius: 4px;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.08);
`;
